// extracted by mini-css-extract-plugin
export default {"content":"RentalChange_content__ZFe+v t-20","cards":"RentalChange_cards__MdFXN df","details":"RentalChange_details__qXu4w","changeBlock":"RentalChange_changeBlock__8yc++"};